import * as React from 'react';

import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';

import '@app/scss/style.scss';

const Layout: React.FC = ({ children }) => {
	return (
		<RequestProvider>
			<div className="app-container">
				{children}
			</div>
		</RequestProvider>
	);
};

export default Layout;
